import React, { CSSProperties } from "react";
import { getThemeColors, getComponentColors, Theme } from "../../theme/colors";

interface SharedDetailsPopupProps {
  isOpen: boolean;
  onClose: () => void;
  sharedWithUsers: string[];
  sourceCategory: "shared-chats" | "shared-with-me" | null;
  username: string;
  colorMode: string;
}

export const SharedDetailsPopup: React.FC<SharedDetailsPopupProps> = ({
  isOpen,
  onClose,
  sharedWithUsers,
  sourceCategory,
  username,
  colorMode,
}) => {
  const currentColors = getThemeColors(username, colorMode as Theme);
  const sidebarColors = getComponentColors("sidebar", colorMode as Theme);

  const buttonStyle: CSSProperties = {
    borderWidth: "1px",
    borderColor: currentColors.border,
    borderRadius: "4px",
    padding: "0.5rem",
    justifyContent: "flex-start",
    transition: "all ease 0.5s",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: currentColors.text,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  const buttonHoverStyle: CSSProperties = {
    backgroundColor: sidebarColors.buttonHover || currentColors.buttonHover,
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: currentColors.background,
          borderRadius: "8px",
          padding: "1.5rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          minWidth: "320px",
          maxWidth: "90vw",
          border: `1px solid ${currentColors.border}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          style={{
            color: currentColors.text,
            margin: "0 0 1rem 0",
            fontSize: "1.1rem",
            fontWeight: 600,
          }}
        >
          {sourceCategory === "shared-with-me" ? "Shared By" : "Shared With"}
        </h3>
        <div style={{ marginBottom: "1rem" }}>
          {sharedWithUsers.length > 0 ? (
            <ul style={{ margin: 0, paddingLeft: "1.25rem" }}>
              {sharedWithUsers.map((user) => (
                <li
                  key={user}
                  style={{
                    color: currentColors.text,
                    marginBottom: "0.25rem",
                  }}
                >
                  {user}
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ color: currentColors.text, opacity: 0.8 }}>
              No users.
            </div>
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            style={{
              ...buttonStyle,
              padding: "0.5rem 1rem",
              backgroundColor: "transparent",
              border: `1px solid ${currentColors.border}`,
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                buttonHoverStyle.backgroundColor || "";
            }}
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
